<app-header-title [title]="title"></app-header-title>
<div class="container-fluid px-3 pt-3">
  <div class="row g-3 masonry-container">
    <div class="col-1 m-0 masonry-sizer"></div>
    <!-- keep all the component tiles below this div -->

    <app-tile-recent-clients class="col-12 col-xl-6"></app-tile-recent-clients>
    <app-overdrawn-account-tile
      class="col-12 col-xl-6"
    ></app-overdrawn-account-tile>
  </div>
</div>
